module.exports = __webpack_public_path__ + "static/media/why_it.cce3d9aa.vtt";